export enum StatusLightSizesEnum {
  SIX = 6,
  EIGHT = 8,
  TEN = 10,
  TWELVE = 12,
  SIXTEEN = 16,
}
